const styles: { [key: string]: string } = {
  n: 'Normal',
  o: 'Oblique',
  i: 'Italic',
};
const transformFontFamily = (fontFamily: string) => {
  const [family, types] = fontFamily.split(':');
  let typeString = '';
  if (!types || types.includes(' - ')) {
    typeString = types || 'No types specified';
  } else {
    typeString = types
      ? types
          .split(',')
          .map((type) => {
            const [style, weight] = type.split('');
            return `${styles[style]} - ${weight}00`;
          })
          .join(', ')
      : '';
  }
  return {
    fontFamily: family,
    fontTypes: typeString,
  };
};
export { transformFontFamily };
